import { render, staticRenderFns } from "./sales-daily.vue?vue&type=template&id=6a8d4c04&scoped=true&"
import script from "./sales-daily.vue?vue&type=script&lang=js&"
export * from "./sales-daily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d4c04",
  null
  
)

export default component.exports